<template>
    <div class="sdr-box contact-box" style="border: 3px solid #da1615;">
        <h4
            style="color: #3b79b0; font-weight:700;"
            v-html="importantinfosheader[getCurrentLocale]"
        ></h4>
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-insurance"></i><a href="/infos-serviceonboard/#/serviceonboard"> {{ importantinfostext[getCurrentLocale] }}</a></span>
        </address>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    /* >>> *************************************************************** / /* Data */
    data: function() {
        return {
            importantinfosheader: {
                en: 'Important infomation',
                de: 'Wichtige Hinweise',
            },
            importantinfostext: {
                en: 'for seat and special reservations',
                de: 'für Sitzplatz- und Servicereservierung',
            },
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: {

        ...mapGetters(['getCurrentLocale']),

    }, // eof computed{}
    /* <<< ****************************************************************/
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/sidebar/Covid19Box.vue